import axios from "axios";

export const state = {
    staffleaves: [],
};

export const getters = {
    staffleaves: state => state.staffleaves,
};

export const mutations = {
    setStaffLeaves(state, newValue) {
        state.staffleaves = newValue
    },
};

export const actions = {
    fetchStaffLeaves({ commit }) {
        axios.get('/staffleaves').then(res => {
            commit('setStaffLeaves', res.data.staffleaves);
        })
    },
};